
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as giM2FiWWxgIRBsGMkQk_B7Vpl6ot0eoNPYdom2732VTYMeta } from "/codebuild/output/src3229005287/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexIpKb1dseaet_45nDBXY9gRHRbubam33XSQO8YGYcnFR40Meta } from "/codebuild/output/src3229005287/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchPcmrDQ2AW9OvG6qbQFc0ytFUHeVSlEOEb8M0EPGS95oMeta } from "/codebuild/output/src3229005287/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexp1Ab4ErwPoBPBbyGsDGeVZwNaeWxMruk6kjeMDYk1b8Meta } from "/codebuild/output/src3229005287/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93Bv9_tXLjjpUbB_9lliLsCKZTeKXTWZo8_45UxaCE169DIMeta } from "/codebuild/output/src3229005287/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexEk1iE0JDB91blz1GrPsgZ_0zaQeETWucHx7jOlEC6SEMeta } from "/codebuild/output/src3229005287/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_936cyhfjAeR9uo2C3tVXKlUOIqzwbEPcOLtV9A1C92kT0Meta } from "/codebuild/output/src3229005287/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexEINqKr51FpKIlcAto7mipbFmWYEf7ExifEOzNtYekDsMeta } from "/codebuild/output/src3229005287/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93ZMnbtarrzONTQLxn_eV6v2UOb8H1EcWIIyEqeTTmqv8Meta } from "/codebuild/output/src3229005287/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index_45UNfoL4D_4507dxsoFbCQ79YrtHgzoA_457Sme5IEqTfEdsMeta } from "/codebuild/output/src3229005287/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index2LkoTTG_45Z2x592iAi8bI_7G2jk7ZZ853NlApepwhyV8Meta } from "/codebuild/output/src3229005287/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3229005287/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3229005287/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3229005287/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3229005287/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3229005287/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexEk1iE0JDB91blz1GrPsgZ_0zaQeETWucHx7jOlEC6SEMeta || {},
    component: () => import("/codebuild/output/src3229005287/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3229005287/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexEINqKr51FpKIlcAto7mipbFmWYEf7ExifEOzNtYekDsMeta || {},
    component: () => import("/codebuild/output/src3229005287/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3229005287/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index_45UNfoL4D_4507dxsoFbCQ79YrtHgzoA_457Sme5IEqTfEdsMeta || {},
    component: () => import("/codebuild/output/src3229005287/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index2LkoTTG_45Z2x592iAi8bI_7G2jk7ZZ853NlApepwhyV8Meta || {},
    component: () => import("/codebuild/output/src3229005287/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]